import { FaqSection } from '@cinch-nx/data-storyblok'

export const supportContactContent = {
  whatsAppHeading: 'WhatsApp us',
  whatsAppHref: 'https://wa.me/447831910589',
  smsHref: 'sms:+442033224567',
  whatsAppBody:
    'Message one of our friendly team. They’re online Mon–Sat from 8am to 6pm.',
  whatsAppCta: 'WhatsApp',
  textHeading: 'Text us',
  textBody:
    'Message one of our friendly team. They’re online Mon–Sat from 8am to 6pm.',
  textCta: 'Text',
  emailHeading: 'Email us',
  emailBody: 'Got a question? Email us and we’ll get back to you.',
  emailCta: 'hello@cinch.co.uk',
  emailHref: 'mailto:hello@cinch.co.uk',
  callHeading: 'Call us',
  callBody:
    'Prefer to talk to someone on the phone? For sales enquiries lines are open Mon–Sat 8am–6pm and Sun 10am-4pm. For aftersales enquiries, lines are open Mon–Sat 8am–6pm.',
  callCta: '0333 015 4101',

  complaintsEmailCta: 'complaints@cinch.co.uk',
  complaintsAddress:
    'Cinch Cars Limited, Form 2, 18 Bartley Wood Business Park, Bartley Way, Hook, Hampshire RG27 9XA',
  complaintsHeading1: 'If you’ve got a complaint here’s what to do:',
  complaintsParagraphs1: [
    'At cinch, because every customer is important to us we aim to provide a quick, courteous, and fair resolution to any customer complaint.',
    'If something isn’t right then we want to hear about it so we can get it resolved for you as quickly as possible.',
    'In order to make a complaint you can contact us by one of the following methods:',
  ],
  complaintsHeading2: 'What happens next:',
  complaintsParagraphs2: [
    'We will need to complete some Data Protection checks, and then we will take details from you about what went wrong, so we can investigate your complaint and work out what we need to do to put things right.',
    'If we can resolve your complaint within 3 days, we will do so, and then email you to confirm we have closed the complaint and the actions taken.',
    'If things are a little more complicated and are going to take longer to put right, we will email you to acknowledge your complaint in writing and set out the next steps.',
    'If we cannot resolve your complaint, we will issue you a Final Response Letter. This will detail which of the following escalation options may apply to you and any timescales in which you will need to refer your complaint.',
    'If we are unable to resolve your complaint in respect of goods supplied by us, you may refer the matter for independent Alternative Dispute Resolution (ADR) to South Yorkshire Trading Standards Services. You can find more information about them <a href="http://www.doncaster.gov.uk/services/business-investment/alternative-dispute-resolution-for-consumers" target="_blank" aria-label="Alternative Dispute Resolution">here</a>.',
    `If we are unable to resolve your complaint in respect of regulated activity, (for example where we have acted as a credit broker) you may refer the matter for independent Alternative Dispute Resolution (ADR) to The Financial Ombudsman Service. You can find more information about them <a href="https://www.financial-ombudsman.org.uk/" target="_blank" aria-label="The Financial Ombudsman Service">here</a>.`,
    `We will abide by any final decision made by either South Yorkshire Trading Standards or the Financial Ombudsman Service.`,
  ],
  pressHeading: 'Press enquiries',
  pressBody: 'For any media enquiries whatsoever, please email',
  pressCta: 'press@cinch.co.uk',
  faqHeading: 'Got a Q? We’ve got the A',
  faqBody:
    'Find everything from how we pick our cars to the different ways you can pay for one.',
  addressHeading: 'Address',
  address: {
    organisationName: 'Cinch Cars Limited',
    buildingName: 'Form 2, 18 Bartley Wood Business Park,',
    thoroughfare: 'Bartley Way, Hook,',
    postTown: 'Hampshire',
    postcode: 'RG27 9XA',
    country: 'UK',
  },
  companyRegistrationInformation:
    'Registered in England and Wales with company number 11520330 and VAT registration number 360909784',
  footerHeading: "Let's find your next car",
  footerCta: 'Search',
}

export const mockFaqs = [
  {
    _uid: 'bba3a09c-8363-4a7a-b163-6cef3153a5a8',
    faqs: [
      {
        _uid: '754c4926-8bba-40b8-8c59-b7037a437eda',
        body: {
          type: 'doc',
          content: [
            {
              type: 'paragraph',
              content: [
                {
                  text: 'No, we don’t sell new cars. But every car we sell online is thoroughly inspected and carefully reconditioned by highly trained technicians – so you can be certain you’re buying a quality car.',
                  type: 'text',
                },
              ],
            },
          ],
        },
        title: 'Do cinch offer new cars?',
        component: 'AccordionItem',
      },
    ],
    title: 'cinch cars…what to expect',
    component: 'FaqSection',
  },
] as unknown as FaqSection[]
